import {fetchAndInsertVisual} from './blogPostVisuals.js';

fetchAndInsertVisual("/stuff/2023-12-09-extra-visual1.json", "5ffe2e7c-954e-11ee-8fc1-daa4de339950", "cov-kernel2", "cov-kernel-content2", 0);
